'use strict';

var _ = require('lodash');
var DowConversionService = function DowConversionService() {
  var ALL_DOW_IDS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var ALL_DOW_IDS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function shortIdToFullId(shortIds) {
    return _.map(shortIds, function (id) {
      return ALL_DOW_IDS_FULL[ALL_DOW_IDS.indexOf(id.toLowerCase())];
    });
  }
  return {
    shortIdToFullId: shortIdToFullId
  };
};
DowConversionService.$inject = [];
module.exports = DowConversionService;